<template>
  <TransparentCard container-tag="section" container-class="achievments_prof col_3">
    <div class="title">
      <div class="left">
        <BaseImage
          src="/static/images/profile_ach.svg"
          alt="Achievements"
        />
      </div>

      <div class="right">
        <h1>{{ $_translations.value.page_profile_overview_section_achievements_title }}</h1>

        <p v-if="hasAchievements">
          <span>{{ totalUnlockedAchievements }}</span> / {{ totalAchievements }}
          {{ $_translations.value.page_profile_overview_section_achievements_subtitle }}
        </p>
      </div>
    </div>

    <div class="achievement_badges">
      <AchievementBadgeItem
        v-for="item in achievementList"
        :key="item.achievementName"
        :item="item"
        @show:achievementDetails="handleShowAchievementDetails(item)"
      />
    </div>
  </TransparentCard>

  <AchievementModal
    v-if="isAchievementModalOpen"
    :data="selectedAchievement"
  />
</template>

<script setup>
import { computed, ref } from 'vue';
import TransparentCard from '@/components/card/TransparentCard.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import AchievementBadgeItem from '@/views/profileOverview/components/item/AchievementBadgeItem.vue';
import AchievementModal from '@/components/modal/achievement/AchievementModal.vue';
import useAuthStore from '@/store/modules/auth.js';
import useModalHook from '@/hooks/useModal.js';

const authStore = useAuthStore();

const [isAchievementModalOpen, openAchievementModal] = useModalHook();

const selectedAchievement = ref(null);

const achievementList = computed(() =>
  authStore.achievementsConfig.list.map((achievement) => ({
    __category: achievement.__category,
    achievementName: achievement.achievementName,
    details: achievement.detailsList.toSorted((a, b) => b.achievementLevelName.localeCompare(a.achievementLevelName))[0],
  })),
);

const totalAchievements = computed(() => achievementList.value.length);

const hasAchievements = computed(() => totalAchievements.value > 0);

const totalUnlockedAchievements = computed(() => authStore.achievementsConfig.totalUnlocked);

const handleShowAchievementDetails = (achievement) => {
  selectedAchievement.value = achievement;

  openAchievementModal({
    afterHideCallback: () => {
      selectedAchievement.value = null;
    },
  });
};
</script>
